import { render, staticRenderFns } from "./HeaderWayi.vue?vue&type=template&id=0520bcbb&scoped=true"
import script from "./HeaderWayi.vue?vue&type=script&lang=js"
export * from "./HeaderWayi.vue?vue&type=script&lang=js"
import style0 from "./HeaderWayi.vue?vue&type=style&index=0&id=0520bcbb&prod&lang=css"
import style1 from "./HeaderWayi.vue?vue&type=style&index=1&id=0520bcbb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0520bcbb",
  null
  
)

export default component.exports